import React from 'react';

import { useContentWrapperContext } from '../ContentWrapper';
import { useHideOnScroll } from '../hooks/useHideOnScroll';
import { useScrollIndicator } from '../hooks/useScrollIndicator';
import { ScrollIndicator } from './ScrollIndicator';

import './MobileContent.scss';

export const MobileContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { toggleControls } = useContentWrapperContext();

  const wrapperRef = useHideOnScroll(toggleControls);
  const { showScrollIndicator, isOverflowingMeasurer } = useScrollIndicator(wrapperRef);

  // Toggle toolbar controls to ON, after content rerenders
  React.useEffect(() => {
    toggleControls(true);
  }, [toggleControls]);

  return (
    <div
      ref={(ref) => {
        wrapperRef.current = ref;
        if (ref) {
          isOverflowingMeasurer(ref);
        }
      }}
      className="content-wrapper__mobile-content"
    >
      {children}
      <ScrollIndicator isVisible={showScrollIndicator} />
    </div>
  );
};
